<div #outer class="tabs-outer">
  <div class="tabs-track">
    <!-- Sliding thumb: sized and moved from the component -->
    <span #thumb class="tabs-thumb" aria-hidden="true"></span>

    @for (link of tabList; track i; let i = $index) {
      <a
        #tabEl
        class="tab-item"
        [class.active]="activeIndex === i"
        [attr.aria-current]="activeIndex === i ? 'page' : null"
        [routerLink]="link.link"
        [queryParams]="link.queryParams ?? null"
      >
        <span class="tab-label" [attr.data-label]="link.title">{{ link.title }}</span>
        @if (link.count !== undefined) {
          <span class="tab-count">{{ formatCount(link.count) }}</span>
        }
      </a>
    }
  </div>
</div>
